import styled from 'styled-components';
import { IThemeProvider } from '../../../styles/theme';

export const ReportGroupComparisonCont = styled.div`
  ${({theme}:IThemeProvider) => `
    margin: ${theme.layout.spacing.decy} 0 0;
  `}
`;

export const GroupComparisonContent = styled.div`
  ${({theme}: IThemeProvider) => `
    padding: 0 ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.centy};
  `}
`;

export const BottomBorder = styled.div`
  ${({theme}: IThemeProvider) => `
    border-bottom: 1px solid ${theme.colors.neutral.primary[30]};
  `}
`;